/* Geroprotect 2026 brand shell: chapter state, progress and restrained reveals. */
(function () {
  'use strict';

  var observers = [];
  var removeScroll = null;

  function cleanup() {
    observers.forEach(function (observer) { observer.disconnect(); });
    observers = [];
    if (removeScroll) removeScroll();
    removeScroll = null;
  }

  function initRail() {
    var rail = document.querySelector('[data-gp-chapter-rail]');
    if (!rail) return;
    var links = Array.prototype.slice.call(rail.querySelectorAll('[data-gp-rail-link]'));
    var fill = rail.querySelector('[data-gp-rail-progress]');
    var ticking = false;

    function setActive(id) {
      links.forEach(function (link) {
        var active = link.getAttribute('data-gp-rail-link') === id;
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    if ('IntersectionObserver' in window) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
      links.forEach(function (link) {
        var section = document.getElementById(link.getAttribute('data-gp-rail-link'));
        if (section) sectionObserver.observe(section);
      });
      observers.push(sectionObserver);
    }

    function updateProgress() {
      ticking = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var progress = Math.max(0, Math.min(1, window.scrollY / max));
      if (fill) fill.style.setProperty('--gp-page-progress', progress.toFixed(4));
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    removeScroll = function () { window.removeEventListener('scroll', onScroll); };
    updateProgress();
  }

  function initReveals() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;
    var items = document.querySelectorAll('.gp-formula__card, .gp-shop__card, .gp-science__card, .gp-faq__item, .article-card, .card-wrapper');
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gp-reveal--in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item) {
      item.classList.add('gp-reveal');
      revealObserver.observe(item);
    });
    observers.push(revealObserver);
  }

  function init() {
    cleanup();
    initRail();
    initReveals();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
